export enum HeaderTab {
    Home,
    PumpSystems,
    FanSystems
}
